// src/components/HeatMapLayer.tsx
import { useEffect } from 'react';
import { useMap } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet.heat';

// Type for heat data
export type HeatPoint = [number, number, number]; // [lat, lng, intensity]

interface HeatMapLayerProps {
  data: HeatPoint[];
  radius?: number;
  blur?: number;
  maxZoom?: number;
  minOpacity?: number;
}

const HeatMapLayer: React.FC<HeatMapLayerProps> = ({
  data,
  radius = 15,
  blur = 8,
  maxZoom = 17,
  minOpacity = 0.5,
}) => {
  const map = useMap();

  useEffect(() => {
    // Only render if we have data
    if (!data || data.length === 0) {
      return;
    }

    // Create heat layer with gradient colors
    const heatLayer = (L as any)
      .heatLayer(data, {
        radius,
        blur,
        maxZoom,
        minOpacity,
        gradient: {
          0.0: '#235AF9',
          0.2: '#00875a',
          0.4: '#F2C94C',
          0.6: '#FF9800',
          0.8: '#FF9800',
          1.0: '#FF0000',
        },
      })
      .addTo(map);

    // Cleanup - remove old layer before creating new one
    return () => {
      if (heatLayer && map.hasLayer(heatLayer)) {
        map.removeLayer(heatLayer);
      }
    };
  }, [data, map, radius, blur, maxZoom, minOpacity]);

  return null;
};

export default HeatMapLayer;
